/*
 * @Author: Dom
 * @Date: 2022-05-31 10:43:06
 * @LastEditTime: 2022-07-15 15:36:38
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activation\store.ts
 */
import {Mutation,Action} from 'vuex';
import { StoreModuleType } from "@/utils/store";
import {ResponseData} from '@/utils/request'
import {verifyEmail} from './service';
import {VerifyEmailParams, VerifyEmailResType} from './data.d'

export interface StateType {
    errorMsg?: string;
    info: VerifyEmailResType;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getInfo: Mutation<StateType>;
    };
    actions: {
        verifyEmailFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    info: {
        activationTime: '', 
        authenticationStatus: '',
        contractStatus: '',
        createdAt: '',
        email: '',
        id: '',
        mobilePrefix: '',
        password: '',
        registerName: '',
        remarks: '',
        status: '',
        updatedAt: '',
        userCode: '',
        userPhone: '',
        userType: '',
    }
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'verifyemail',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getInfo(state, payload) {
            state.info = payload;
        }
    },
    actions: {
        async verifyEmailFn({ commit },params:VerifyEmailParams){
            let msg: string | undefined = undefined
            try{
                const req:ResponseData = await verifyEmail(params)
                const {body} = req
                body&&commit('getInfo', body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }

            commit('changeErrorMsg',msg);

            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel
